import axios from "axios";
axios.defaults.withCredentials = true;
export const reportAPI = async(API) => {
    try {
        const responseData = await axios.get(API);
        alert(responseData?.data?.data || responseData?.data?.message);
        return true;
    } catch (error) {
        return false;
    }
}